import React, { useState } from "react";
import ContactUsTemplate from "./contact-us.template";
const ContactUsComponent = () => {
    const [greet, setGreet] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission here
        console.log('Form submitted:', formData);
        // alert('Thank you for your message. We will get back to you soon!');
        setGreet(true);
        setDisabled(true);
        setTimeout(() => {
            setGreet(false);
            setDisabled(false);
        }, 3000000);
        setFormData({ name: '', email: '', subject: '', message: '' });
    };

    const Message = ({ type, title, text }) => {
        if (!type) return null;
    
        const cardClass = type === "success" ? "sucess-card" : "red-card";
        return (  
          <div className="email-cart">
            <div className="row justify-content-md-center">
              <div className={`card-body ${cardClass} h-auto`}>
                <h5 className="card-title text-center mt-1">{title}</h5>
                <p className="card-text">{text}</p>
              </div>
            </div>
          </div>
        );
      };

    const templateData = {
        formData,
        greet,
        disabled,
    };

    const templateEvents = {
        handleChange,
        handleSubmit,
        Message,
    };
    return (
        <ContactUsTemplate 
        templateData={templateData}
        templateEvents={templateEvents}/>
    );
};
export default ContactUsComponent;
